const styles = theme => ({
  imageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    alignSelf: 'stretch',
  },
  imageHeader: {
    color: 'var(--mcg-dark, #002E47)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    alignSelf: 'stretch',
  },
  learnMore: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '18px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    marginRight: '16px',
  },
  imageText: {
    color: 'var(--mcg-gray, #919EAB)',
    /* Body/Body 6 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px' /* 163.636% */,
  },
  background: {
    display: 'flex',
    height: '220px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '12px',
  },
  button: {
    borderRadius: '6px',
    background: 'var(--mcg-white, #FFF)',
    display: 'flex',
    height: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '7px var(--12, 12px)',
    cursor: 'pointer',
  },
  buttonText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFeatureSettings: `'liga' off, 'clig' off`,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '18px' /* 150% */,
  },
})

export default styles
